import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { IListView } from '@shared/interfaces/various/IListView';
import { IResponsible } from '@shared/interfaces';

@Injectable()
export class TreeDatabase {
    dataChange = new BehaviorSubject<IListView<IResponsible> & Partial<IResponsible>>(null);

    constructor() {
        /* Constructor */
    }

    get data(): IListView<IResponsible> & Partial<IResponsible> {
        return this.dataChange.value;
    }

    set data(item: IListView<IResponsible> & Partial<IResponsible>) {
        this.dataChange.next(item);
    }

    findOrgItemByCode(code: string): IResponsible {
        return this.data?.orgCode === code ? this.data : this.data?.children?.find(e => e.orgCode === code);
    }
}
